/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Forward_Email_AddressInputs */

const en_dialog_forward_email_address = /** @type {(inputs: Dialog_Forward_Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`listen@mail.listening.io`)
};

const es_dialog_forward_email_address = /** @type {(inputs: Dialog_Forward_Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`listen@mail.listening.io`)
};

/**
* | output |
* | --- |
* | "listen@mail.listening.io" |
*
* @param {Dialog_Forward_Email_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_forward_email_address = /** @type {((inputs?: Dialog_Forward_Email_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Forward_Email_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_forward_email_address(inputs)
	return en_dialog_forward_email_address(inputs)
});